import * as yup from 'yup';

export const CustomFieldNameValidationScheme = yup.object().shape(
	{
		customColumn1: yup
			.string()
			.nullable(),
        customColumn2: yup
			.string()
			.nullable(),
        customColumn3: yup
			.string()
			.nullable(),
        customColumn4: yup
            .string()
			.nullable(),
        customColumn5: yup
			.string()
			.nullable(),
	}
);
